import { render, staticRenderFns } from "./import-doe-payment.vue?vue&type=template&id=bda52c02&"
import script from "./import-doe-payment.vue?vue&type=script&lang=js&"
export * from "./import-doe-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports